const DIALOG_TYPES = {
  CONFIRMATION: 'confirmation',
  SEND: 'send',
  INFO: 'info',
  DELETE: 'delete',
  DEFAULT: 'default',
};

export { DIALOG_TYPES };
